import React from 'react'
import { number } from 'prop-types'

function Quality({ width = 16, height = 16, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.8273 2.4429L8.92283 1.67246C8.66542 1.45288 8.33818
        1.33301 7.99985 1.33301C7.66152 1.33301 7.33427 1.45362
        7.07686 1.6732L6.1724 2.44364C5.94457 2.63794 5.66123 2.75538
        5.36275 2.77922L4.17902 2.8733C3.84176 2.89989 3.52503 3.04583
        3.28568 3.28493C3.04632 3.52402 2.90003 3.84061 2.87306 4.17786L2.77824
        5.36241C2.75454 5.66095 2.63824 5.94394 2.44342 6.17211L1.67303
        7.07737C1.45387 7.33469 1.3335 7.66166 1.3335 7.99967C1.3335 8.33769
        1.45387 8.66466 1.67303 8.92198L2.44342 9.82724C2.63757 10.0549
        2.755 10.338 2.77899 10.6362L2.8738 11.8207C2.90053 12.1578
        3.04643 12.4743 3.28535 12.7135C3.52426 12.9527 3.84056 13.0989
        4.17754 13.126L5.36275 13.2209C5.6614 13.2443 5.94501 13.3615
        6.17314 13.5557L7.07686 14.3262C7.33427 14.5457 7.66152 14.6663
        7.99985 14.6663C8.33818 14.6663 8.66542 14.5457 8.92283 14.3262L9.8273
        13.5557C10.0552 13.3617 10.3386 13.2445 10.6369 13.2209L11.8222
        13.126C12.159 13.099 12.4752 12.9528 12.7141 12.7137C12.953 12.4747
        13.099 12.1584 13.1259 11.8215L13.2207 10.6362C13.2444 10.3377 13.3622
        10.0547 13.5563 9.8265L14.3267 8.92198C14.5462 8.66455 14.6668 8.33728
        14.6668 7.99893C14.6668 7.66058 14.5462 7.33332 14.3267 7.07589L13.5563
        6.17211C13.3622 5.94468 13.2444 5.66095 13.22 5.36241L13.1259 4.17712C13.0988
        3.84024 12.9526 3.52401 12.7136 3.2851C12.4746 3.04619 12.1583 2.9002 11.8214
        2.8733L10.6362 2.77848C10.3384 2.75403 10.0555 2.63699 9.8273 2.4429ZM7.33352
        10.2758L10.943 6.66636L10.0002 5.72355L7.33352 8.39022L6.00018 7.05688L5.05737 7.99969L7.33352 10.2758Z"
        fill="#73ABF5"
      />
    </svg>
  )
}

Quality.propTypes = {
  width: number,
  height: number,
}

export default Quality
